import React from 'react';
import RadioPlayer from './components/RadioPlayer';

function App() {
  const streamUrl = "http://stream.radiojar.com/98mxa4t2c0nwv";
  const logoUrl = "https://media-manager-c.questera.ai/greta-media/43aece2c60808d1ccb768fe9bea97d59a6d817dd340535725dd5c7fa72ea8e057f5a392df509537a8b1d8bce30fb3a2f/images/aW1hZ2UvanBlZw==/940fed55ead5745df056cf189658325c.jpg";

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex flex-col items-center justify-center py-12 px-6">
      <div className="mb-12 text-center">
        <h1 className="text-sm font-black text-[#00AEEF] uppercase tracking-[0.4em] mb-2">Broadcasting Live</h1>
        <div className="h-1 w-20 bg-[#00AEEF] mx-auto rounded-full"></div>
      </div>
      
      <RadioPlayer streamUrl={streamUrl} logoUrl={logoUrl} />
      
      <p className="mt-12 text-gray-400 text-[10px] font-bold uppercase tracking-widest">
        &copy; {new Date().getFullYear()} Console Radio Digital
      </p>
    </div>
  );
}

export default App;